export default __webpack_public_path__ + "static/media/enterpriseSaml.8742789b.svg";